import React, {FC} from "react"
import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Body, H3, H5} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import Markdown from "@irati/ui/src/Markdown"
import CashbackWalletAssetOne from "../../images/cashback_wallet_modal_asset_01.svg"
import CashbackWalletAssetTwo from "../../images/cashback_wallet_modal_asset_02.svg"
import CashbackWalletAssetThree from "../../images/cashback_wallet_modal_asset_03.svg"

interface Props {
  closeModal: () => void
}

const StyledFlex = styled(Flex)`
  background-color: ${({theme}) => theme.colors.greys.grey03};
  border-radius: ${({theme}) => theme.border.radius.extraLarge};
  padding: ${({theme}) => theme.spacing.oneAndHalf};
  align-items: flex-start;
`

const CashbackModalContent: FC<Props> = ({closeModal}) => {
  return (
    <Flex direction="column" gap={2}>
      <Flex direction="column" alignItems="center" justifyContent="center" gap={3}>
        <H3>
          <FormattedMessage id="platform.cashback.infoModal.title" />
        </H3>
        <Body small>
          <FormattedMessage id="platform.cashback.infoModal.subtitle" />
        </Body>
      </Flex>

      <StyledFlex>
        <img src={CashbackWalletAssetOne} alt="asset-one" />
        <Flex direction="column" marginLeft={2}>
          <H5>
            <FormattedMessage id="platform.cashback.infoModal.questionOne" />
          </H5>
          <Body small>
            <FormattedMessage id="platform.cashback.infoModal.answerOne" />
          </Body>
        </Flex>
      </StyledFlex>
      <StyledFlex>
        <img src={CashbackWalletAssetTwo} alt="asset-two" />
        <Flex direction="column" marginLeft={2}>
          <H5>
            <FormattedMessage id="platform.cashback.infoModal.questionTwo" />
          </H5>
          <Body small>
            <FormattedMessage
              id="platform.cashback.infoModal.answerTwo"
              values={{
                pending: (
                  <Body small weight="bold" display="inline">
                    <FormattedMessage id="platform.wallet.menu.user.pending" />
                  </Body>
                )
              }}
            />
          </Body>
        </Flex>
      </StyledFlex>
      <StyledFlex>
        <img src={CashbackWalletAssetThree} alt="asset-three" />
        <Flex direction="column" marginLeft={2}>
          <H5>
            <FormattedMessage id="platform.cashback.infoModal.questionThree" />
          </H5>
          <Body small>
            <FormattedMessage
              id="platform.cashback.infoModal.answerThree"
              values={{
                availableBalance: (
                  <Body small weight="bold" display="inline">
                    <FormattedMessage id="wallet.sendCredit.availableBalance.title" />
                  </Body>
                )
              }}
            />
          </Body>
        </Flex>
      </StyledFlex>
      <Flex onClick={(e) => e.stopPropagation()}>
        <Markdown source="platform.cashback.CashbackModal.help" componentProps={{body: {small: true}}} />
      </Flex>
      <Button primary full large onClick={closeModal}>
        <FormattedMessage id="platform.wallet.TreatTokensModal.button.gotIt" />
      </Button>
    </Flex>
  )
}

export default CashbackModalContent
